export default "ui-fieldset+ui-fieldset{display:block;margin-top:20px}\n";